import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export const AlertDialog = ({
  show,
  title,
  content,
  agreeAction,
  disagreeAction,
  handleAgree,
  handleDisagree,
}) => {
  let open = show;
  // useEffect(() => {
  //   setOpen(show);
  // }, [setOpen]);

  const handleClose = () => {
    open = false;
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {disagreeAction && (
            <Button onClick={handleDisagree}>{disagreeAction}</Button>
          )}
          {agreeAction && (
            <Button onClick={handleAgree} autoFocus>
              {agreeAction}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};
